import { formDataRequest ,postRequest} from "../libs/AxiosService.util";

export async function serviceCreateBroadcast(params) {
  return await formDataRequest("whatsapp/broadcasts/create", params);
}
export async function serviceUpdateBroadcast(params) {
  return await postRequest("whatsapp/broadcasts/update", params);
}
export async function serviceGetBroadcastDetails(params) {
  return await postRequest("whatsapp/broadcasts/detail", params);
}
export async function serviceGetBroadcast(params) {
  return await postRequest("whatsapp/broadcasts", params);
}
export async function serviceGetBroadcastContactCount(params) {
  return await postRequest("whatsapp/broadcasts/contact/count", params);
}
export async function serviceRecipientList(params) {
  return await postRequest("whatsapp/broadcasts/logs", params);
}
export async function serviceStopBroadcasting(params) {
  return await postRequest("whatsapp/broadcasts/cancel/retry", params);
}

